import { createRoot } from "react-dom/client";

import { Hassibot } from "./startup/typed-index";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<Hassibot />);
